var irreducible = require('./irreducible');

module.exports = irreducible('Date', function (x) { return x instanceof Date; });



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/Date.js
 ** module id = 1030
 ** module chunks = 0
 **/